export default {
  api: {
    baseUrl: process.env.REACT_APP_API_URL,
    cdn: process.env.REACT_APP_API_CDN,
  },
  form: {
    inputFieldMaxLength: 300,
  },
};
